import { useTranslation } from 'react-i18next'

type PolicyNamespace = 'privacyPolicy' | 'cookiePolicy'
type PolicySection = { title: string; body: string }

const PolicyPage = ({ ns }: { ns: PolicyNamespace }) => {
  const { t } = useTranslation()
  const sections = (t(`${ns}.sections`, { returnObjects: true }) as PolicySection[]) ?? []

  return (
    <div className="min-h-screen bg-background font-sans">
      <article className="mx-auto max-w-2xl px-5 py-12 sm:py-16">
        <h1 className="m-0 text-3xl font-bold tracking-tight text-foreground">{t(`${ns}.title`)}</h1>
        <div className="mt-3 h-1 w-12 rounded-full bg-primary" />
        <p className="mt-3 text-xs text-muted-foreground">{t(`${ns}.updatedAt`)}</p>
        <p className="mt-6 text-[15px] leading-relaxed text-muted-foreground">{t(`${ns}.intro`)}</p>

        {sections.map((section, i) => (
          <section key={i} className="mt-8">
            <h2 className="m-0 text-lg font-semibold text-foreground">{section.title}</h2>
            {section.body.split('\n').map((paragraph, j) => (
              <p key={j} className="mt-2 text-[15px] leading-relaxed text-muted-foreground">
                {paragraph}
              </p>
            ))}
          </section>
        ))}
      </article>
    </div>
  )
}

export const PrivacyPolicyPage = () => <PolicyPage ns="privacyPolicy" />
export const CookiePolicyPage = () => <PolicyPage ns="cookiePolicy" />
